export const oops = {
  title: "It's not you, it's us",
  description1: 'Please check your connection or try again later.',
  description2: 'Still nothing?',
  link: 'Contact admin',
};
